export const blockIconsBusinessandpaymentsAddShoppingCartNew = (
	<span className='material-symbols-outlined'>add_shopping_cart</span>
);
